import { Component, OnInit, ViewChild } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { Router, RouterModule } from '@angular/router';
import { SseFormService } from '../../../services/sse/sseForm.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatInput } from '@angular/material/input';

interface SSEEntry {
  name: string;
  index: string;
  checklist: string;
}

@Component({
    selector: 'app-sse-hub',
    imports: [
    MatButtonModule,
    MatCheckboxModule,
    MatInputModule,
    MatRadioModule,
    MatFormFieldModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatTableModule,
    RouterModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatMenuModule
],
    templateUrl: './sse-hub.component.html',
    styleUrl: './sse-hub.component.css'
})
export class SseHubComponent implements OnInit{
  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = ['name', 'index', 'status', 'checklist']; 
  loading: boolean = true; 
  error: string | null = null; 

  @ViewChild('filterInput') filterInput: MatInput;

  constructor(private sseFormService: SseFormService, private router: Router) {}

  ngOnInit(): void {
    this.loadAllSse();
    this.dataSource.filterPredicate = this.customFilterPredicate();
  }



  loadAllSse(): void {
    this.sseFormService.findAllSse().subscribe(
      (response) => {
        const sseData = response?.data || [];
        this.sseFormService.findAllSseList().subscribe(
          (listResponse) => {
            const sseLists = listResponse?.data || [];
            const listMap = new Map(
              sseLists.map((list: any) => [list.indexId, list._id]) 
            );
            sseData.forEach((row: any) => {
              row.sseListId = listMap.get(row._id) || null;
              row.status = this.getIndexStatus(row); 
            });
  
            this.dataSource.data = sseData;
            this.loading = false;
          },
          (listError) => {
            console.error('Error fetching sseList data:', listError);
            this.error = 'Failed to load SSE List data. Please try again later.';
            this.loading = false;
          }
        );
      },
      (error) => {
        console.error('Error fetching SSE data:', error);
        this.error = 'Failed to load SSE data. Please try again later.';
        this.loading = false;
      }
    );
  }

  getIndexStatus(element: any): string {
    if (element.section1?.hrCompleted && !element.section2?.ccCompleted) {
      return 'Crew Manager Pending'; 
    } else if (element.section2?.ccCompleted && !element.section3?.smCompleted) {
      return 'Safety Director Pending'; 
    } else if (element.section3?.smCompleted) {
      return 'Complete'; 
    } else {
      return 'Unknown Status'; 
    }
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  sortData(column: string, direction: 'asc' | 'desc'): void {
    const statusOrder = ['Crew Manager Pending', 'Safety Director Pending', 'Complete']; 
  
    const sortedData = [...this.dataSource.data].sort((a, b) => {
      let valueA: any;
      let valueB: any;
  
      switch (column) {
        case 'name':
          valueA = a.section1?.hrName?.toLowerCase() || '';
          valueB = b.section1?.hrName?.toLowerCase() || '';
          break;
        case 'status':
          valueA = statusOrder.indexOf(this.getIndexStatus(a));
          valueB = statusOrder.indexOf(this.getIndexStatus(b));
          break;
        case 'checklist':
          valueA = a.sseListId ? 1 : 0; 
          valueB = b.sseListId ? 1 : 0;
          break;
      }
  
      if (direction === 'asc') {
        return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
      } else {
        return valueA < valueB ? 1 : valueA > valueB ? -1 : 0;
      }
    });
  
    this.dataSource.data = sortedData; 
  }

  clearSort(): void {
    this.loadAllSse(); 
  }

  customFilterPredicate(): (data: any, filter: string) => boolean {
    return (data: any, filter: string): boolean => {
      const name = data.section1?.hrName?.toLowerCase() || '';
      const index = data._id?.toLowerCase() || '';
      const status = this.getIndexStatus(data).toLowerCase();
      return name.includes(filter) || index.includes(filter) || status.includes(filter);
    };
  }

}
